import React, {Component} from 'react'
import propTypes from 'prop-types'
import {isNil, isEmpty, get} from 'lodash'
import {prefix} from 'helpers/component'
import BaseEditor from './baseEditor'
import Button from 'components/button'
import TextField from '@material-ui/core/TextField'
import {parseCssSelector} from "helpers/css"
import {formatRoundedNumber} from "helpers/financial"

require('./inlineEditor.scss')
const getClassName = prefix('inlineEditor-numberEditor-')

class NumberEditor extends Component {
  state = {
    value: this.props.value,
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.open && nextProps.open) {
      this.setState({value: nextProps.value})
    }
  }

  onFocus = () => {
    document.execCommand('selectAll')
  }

  change = (e) => {
    this.setState({value: e.target.value})
  }

  round = (value, accuracy) => {
    return parseFloat(formatRoundedNumber(value, accuracy))
  }

  commit = () => {
    const {onCommit} = this.props
    const options = this.getOptions()
    let {value} = this.state

    const isValueTypeString = (typeof value === 'string')
    const isNull = isValueTypeString ? (isNil(value) || isEmpty(value)) : isNil(value)

    if (!isNull) {
      value = parseFloat(value)
      if (isNaN(value)) {
        value = null
      } else {
        value = this.round(value, options.accuracy)
        if (!isNil(options.min) && value < options.min) value = options.min
        if (!isNil(options.max) && value > options.max) value = options.max
      }
    } else {
      value = null
    }

    onCommit(value)
  }

  getOptions = () => {
    const {options} = this.props
    const accuracy = get(options, 'accuracy', 0)
    const prepend = get(options, 'prepend', '')
    const append = get(options, 'append', '')
    const min = get(options, 'min')
    const max = get(options, 'max')
    return {
      accuracy,
      prepend,
      append,
      min,
      max,
    }
  }

  cancel = () => {
    this.props.onCancel()
  }

  keyDown = (e) => {
    switch (e.keyCode) {
      case 13:  // ENTER
        this.commit()
        break
      case 27:  // ESC
        this.cancel()
        break
    }
  }

  getStep = (accuracy) => {
    let ret = 1
    if (accuracy > 0) ret /= Math.pow(10, accuracy)
    return ret
  }

  render() {
    const {
      open,
      anchor,
      label,
      width,
      commitLabel,
      cancelLabel,
      commitButtonWidth,
      cancelButtonWidth,
      ...otherProps
    } = this.props
    const {value} = this.state

    const options = this.getOptions()
    const step = this.getStep(options.accuracy)
    const editorWidth = width + commitButtonWidth + cancelButtonWidth + 12

    return (
        <BaseEditor
            open={open}
            anchor={anchor}
            {...otherProps}
            height={48}
            width={editorWidth}
            onClose={this.cancel}>
          {options.prepend}
          <TextField
              className={parseCssSelector(`text-${label}`)}
              placeholder={label}
              type="number"
              value={value || ''}
              onChange={this.change}
              onKeyDown={this.keyDown}
              style={{width}}
              inputProps={{
                min: options.min,
                max: options.max,
                step,
                style: {textAlign: 'right'},
              }}
              autoFocus
              onFocus={this.onFocus}/>
          {options.append}
          <div className={getClassName('buttons')}>
            <Button
                label={cancelLabel}
                flat
                width={cancelButtonWidth}
                onClick={this.cancel}/>
            <Button
                className={parseCssSelector(`button-${label}`)}
                label={commitLabel}
                primary
                width={commitButtonWidth}
                onClick={this.commit}/>
          </div>
        </BaseEditor>
    )
  }
}

NumberEditor.propTypes = {
  value: propTypes.number,
  open: propTypes.bool.isRequired,
  anchor: propTypes.object,
  label: propTypes.string,
  width: propTypes.number,
  options: propTypes.shape({
    accuracy: propTypes.oneOfType([
      propTypes.number,
      propTypes.string,
    ]),
    prepend: propTypes.string,
    append: propTypes.string,
    min: propTypes.number,
    max: propTypes.number,
  }),
  commitLabel: propTypes.string,
  cancelLabel: propTypes.string,
  commitButtonWidth: propTypes.number,
  cancelButtonWidth: propTypes.number,
  onCommit: propTypes.func.isRequired,
  onCancel: propTypes.func.isRequired,
}

NumberEditor.defaultProps = {
  width: 150,
  commitLabel: 'Update',
  cancelLabel: 'Cancel',
  commitButtonWidth: 90,
  cancelButtonWidth: 90,
}

export default NumberEditor
